import { Slide } from '../components/SlideComponents/slide.types';

export const MAX_SCORE_NONE_VALUE = 'none';
export const MAX_SCORE_UNLIMITED = -1;

export type MaxScoreSelectValue = typeof MAX_SCORE_NONE_VALUE | number;
export type MaxScoreOption = { value: MaxScoreSelectValue; displayName: string };

export const MAX_SCORE_OPTIONS: MaxScoreOption[] = [
  { value: MAX_SCORE_NONE_VALUE, displayName: 'None' },
  { value: MAX_SCORE_UNLIMITED, displayName: 'Unlimited' },
  // Start at 1: a `maxScore` of 0 produces a degenerate single-bucket chart
  // (every response clamped to score=0) and still activates the scoreboard
  // flow, which is confusing. Teachers who want to disable scoring should
  // pick "None".
  ...Array.from({ length: 25 }, (_, i) => ({
    value: i + 1,
    displayName: String(i + 1),
  })),
];

export function maxScoreToSelectValue(
  maxScore: number | null | undefined,
): MaxScoreSelectValue {
  return maxScore == null ? MAX_SCORE_NONE_VALUE : maxScore;
}

export function selectValueToMaxScore(
  value: MaxScoreSelectValue | string | number | boolean,
): number | null {
  return value === MAX_SCORE_NONE_VALUE ? null : (value as number);
}

export function hasScorePromptOutput(slide: Slide | undefined | null): boolean {
  if (!slide?.prompts) return false;
  return slide.prompts.some(prompt => {
    const properties = prompt.promptOutput?.properties;
    if (!properties) return false;
    return Object.values(properties).some(property => {
      if (!property) return false;
      if (property.id === 'score') return true;
      const description = property.description?.trim().toLowerCase();
      return description === 'score';
    });
  });
}
